import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { t } from 'utils/translates';

class SearchSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ''
    };
    this.inputRef = React.createRef();
  }

  getVerifiedPropStartValue = () => {
    const searchVal = this.props.selectArrItems.find(
      i => i.id === this.props.value
    );
    console.log(searchVal);
    if (searchVal) {
      return this.props.value;
    }
    return null;
  };

  getSelectValueTitle = () => {
    if (this.props.value === null || this.props.value === '') {
      if (this.props.placeholder !== null) {
        return this.props.placeholder;
      }
      return this.props.selectTitleNullValue || t('Не выбрано');
    }
    return _.get(
      this.props.selectArrItems.find(
        i => i.id.toString() === this.props.value.toString()
      ),
      'title'
    );
  };

  changeValue = async (event, newValue) => {
    event.preventDefault();
    if (newValue !== this.props.value) {
      this.props.handleChangeValue(newValue);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="btn-group bootstrap-select form-control">
          <button
            type="button"
            className="btn dropdown-toggle bs-placeholder btn-default"
            data-toggle="dropdown"
            title={this.getSelectValueTitle()}
            onClick={() => {
              this.inputRef.current.focus();
            }}
          >
            {this.getSelectValueTitle()}
          </button>
          <div
            className="dropdown-menu open"
            style={{
              maxHeight: '264px',
              overflow: 'hidden'
            }}
          >
            <div style={{ padding: '4px 8px 9px' }}>
              <input
                ref={this.inputRef}
                type="text"
                className="form-control"
                placeholder={t('Введите текст для поиска')}
                value={this.state.searchValue}
                onChange={e => this.setState({ searchValue: e.target.value })}
              />
            </div>
            <ul
              className="dropdown-menu inner"
              role="listbox"
              aria-expanded="false"
              style={{
                maxHeight: '252px',
                overflowY: 'auto'
              }}
            >
              {this.props.selectTitleNullValue !== null ? (
                <li
                  className={
                    this.props.value === null || this.props.value === ''
                      ? 'active'
                      : ''
                  }
                >
                  <a href="" onClick={e => this.changeValue(e, null)}>
                    {this.props.selectTitleNullValue || t('Не выбрано')}
                  </a>
                </li>
              ) : null}
              {this.props.selectArrItems
                .filter(item =>
                  item.title
                    .toLowerCase()
                    .includes(this.state.searchValue.toLowerCase())
                )
                .map(item => (
                  <li
                    key={item.title.toString()}
                    className={
                      this.props.value &&
                      this.props.value.toString() === item.id.toString()
                        ? 'active'
                        : ''
                    }
                  >
                    <a href="" onClick={e => this.changeValue(e, item.id)}>
                      {item.title}
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SearchSelect.defaultProps = {
  selectTitleNullValue: undefined,
  placeholder: null,
  value: null
};

SearchSelect.propTypes = {
  // IN PROPS
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectTitleNullValue: PropTypes.string,
  selectArrItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string
    })
  ).isRequired,
  placeholder: PropTypes.string,
  handleChangeValue: PropTypes.func.isRequired
};

export default SearchSelect;



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/SearchSelect/SearchSelect.js